import React from 'react';

const TemplateDownload = ({template}) => {
  return (
    <div className='templateDownload'>
      <span>
        Κατέβασε τις οδηγίες συμπλήρωσης{' '}
        <a
          href={template.docPath}
          download={template.docName}
        >
          εδώ
        </a>
      </span>
    </div>
  );
};

export default TemplateDownload;
